import DisclosureContentProvider from './hooks/useDisclosureContent';

import { DisclosureContentProps } from './@types/DisclosureContentProps';
// import { DisclosureContent as ContentVtex, useDisclosure } from '@vtex/disclosure'

const DisclosureContent = (props: DisclosureContentProps) => {
	//   const { state } = useDisclosure()
	//   const visible = state?.visible
	//   const htmlProps = {
	//     className: `vtex-disclosure-layout-1-x-content vtex-disclosure-layout-1-x-content--${props.blockClass}  vtex-disclosure-layout-1-x-content--${visible ? 'visible' : 'hidden'} vtex-disclosure-layout-1-x-content--${props.blockClass}--${visible ? 'visible' : 'hidden'}`
	//   }

	return (
		<DisclosureContentProvider {...props}>
			{/* <ContentVtex
        htmlProps={htmlProps}
      > */}
			{props.children}
			{/* </ContentVtex> */}
		</DisclosureContentProvider>
	);
};

export default DisclosureContent;
